import { render, staticRenderFns } from "./ModalWhatsapp.vue?vue&type=template&id=ff72bf4a&"
import script from "./ModalWhatsapp.vue?vue&type=script&lang=js&"
export * from "./ModalWhatsapp.vue?vue&type=script&lang=js&"
import style0 from "./ModalWhatsapp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports